module.exports = __webpack_public_path__ + "img/Birthday.ba7fbd7d.jpg";